import { APP } from "@fusiqo/vozqi-shared";

/**
 * The official store badges, linking to the phone app.
 *
 * THE STORES' ARTWORK, UNTOUCHED. Apple and Google both forbid recolouring or
 * redrawing their badges, so these are their Spanish files as published:
 * Apple's es-MX SVG and Google's es-419 PNG with only its transparent margin
 * trimmed. Both are black with a grey border, which reads on the dark theme as
 * well as the light one. Same height side by side, as both guidelines ask;
 * `height` sets it and each width follows its own artwork. Apple asks for at
 * least 40px on screen, hence the default.
 */
const BADGES = [
  {
    platform: "ios",
    href: APP.stores.appStore,
    src: "/brand/app-store-badge.svg",
    alt: "Descárgalo en el App Store",
    ratio: 119.66407 / 40,
  },
  {
    platform: "android",
    href: APP.stores.googlePlay,
    src: "/brand/google-play-badge.png",
    alt: "Descargar en Google Play",
    ratio: 646 / 192,
  },
] as const;

/**
 * `platform` narrows to that phone's store; without it, both. `hrefFor`
 * rewrites each link (a public page sends it through the API's counter, with
 * its campaign); without it, the listing itself.
 */
export function StoreBadges({
  height = 44,
  platform,
  hrefFor,
}: {
  height?: number;
  platform?: "ios" | "android";
  hrefFor?: (store: "ios" | "android") => string;
}) {
  const shown = platform === undefined ? BADGES : BADGES.filter((badge) => badge.platform === platform);
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
      {shown.map((badge) => (
        <a
          key={badge.platform}
          href={hrefFor === undefined ? badge.href : hrefFor(badge.platform)}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "inline-flex" }}
        >
          <img src={badge.src} alt={badge.alt} width={Math.round(height * badge.ratio)} height={height} />
        </a>
      ))}
    </div>
  );
}
